<script>
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import mixinDes from "@/common/mixin/passenger/mixin-des";
/**
 * 对 hs-form-cell 的二次包装 用于 证件号 邮箱 等 脱敏输入
 *
 * */
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    telFunName: {
      type: String,
      default: ''
    },
    MobileCountryCode: {
      type: String,
      default: ''
    },
    // 是否脱敏
    IsEnableDesensitize: { // 是否开启隐私保护
      type: Boolean,
      default: false
    }
  },
  components: {
    HsFormCell
  },
  mixins: [mixinDes],
  watch: {
    value (val) {
      this.setValue(val)
    },
    currentValue(val) {
      if (this.IsChange) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      IsChange: false,
      currentValue: '',
    }
  },
  methods: {
    _focusFun() {
      if (!this.IsChange && this.IsEnableDesensitize) {
        this.currentValue = ''
      }
    },
    _blurFun() {
      this.setValue(this.value)
    },
    _inputChange(type) {
      this.IsChange = true
    },

    setValue(val) {
      if (!this.IsChange && this.IsEnableDesensitize) {
        this.currentValue = this[this.telFunName] && this[this.telFunName](val) || val
      } else {
        this.currentValue = val
      }
    }
  },
  mounted() {
    this.setValue(this.value)
  }
}
</script>

<template>
  <hs-form-cell
      v-model="currentValue"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="_focusFun"
      @blur="_blurFun"
      @input="_inputChange"
  >
    <!-- 插槽内容也可以传递 -->
    <slot></slot>
    <template v-for="(_, slot) in $slots" v-slot:[slot]>
      <slot :name="slot"></slot>
    </template>
  </hs-form-cell>
</template>

<style scoped lang="stylus">

</style>
